import React, { useRef } from "react";
import { Col, Form, Input, Modal, Row, Tooltip, Select, Popover, Space, Spin, InputNumber } from "antd";
import { theme } from 'antd';
import ColorButton from "../../common/ColorButton";
import {
  CheckOutlined,
  HistoryOutlined,
  PlusOutlined,
  MinusCircleOutlined
} from '@ant-design/icons';
import TSTable from "../../common/TSTable";
import { PATH } from "../../routes/CustomRoutes";
import { URL_COMMON, URL_POND, URL_TRUCK } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import _ from "lodash";
import { formatComma, getLabResultColor, toFixed } from "../../frameworks/Util";
import { GET, POST } from "../../frameworks/HttpClient";
import ErrorMessages from "../../common/ErrorMessages";
import { useUserContext } from "../../hooks/UserSettingProvider";

export default function PondFillLatexModal(props) {
  const { open, onUpdate } = props;
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [form] = Form.useForm();
  const [debouncedPond, setDebouncedPond] = React.useState('');
  const [openPopover, setOpenPopover] = React.useState(false);
  const { features } = useUserContext();
  const multiplePondFeature = _.get(features, 'multiple_pond_feature', false)
  const [loading , setLoading] = React.useState(false);
  const debouncePond = React.useCallback(_.debounce((_searchVal) => { setDebouncedPond(_searchVal) }, 800), []);
  const pondDropdown = useDropdownItem({ 
    url: URL_POND.POND,
    manual : true,
    label_renderer: (option) => `${option.name} [${ option.lot_no }]`,
    value:'current_transaction', 
    pagination: true, 
    params: { state: "filling", page_size : 999, name : debouncedPond, } ,
  })
  const tableRef = useRef(null);
  const popoverRef = useRef(null);
  const {
    token: { colorSuccess },
  } = theme.useToken();

  const handleFillLatex = async(truck_id) => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (data.sources && data.sources.length > 0) {
        const result = [
          {
            truck_transaction: truck_id,
            pond_transaction: data.pond_transaction,
            tray: data.tray
          },
          ...data.sources.map((e) => ({
            truck_transaction: truck_id,
            pond_transaction: e.pond_transaction,
            override_weight: e.weight,
            tray: e.tray
          }))
        ];
        await POST(URL_POND.POND_TRUCK_TRANSCATION, result)
      } else {
        const result = {
            truck_transaction: truck_id,
            pond_transaction: data.pond_transaction,
            tray: data.tray
          }
        await POST(URL_POND.POND_TRUCK_TRANSCATION, result)
      }
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const handleAddFields = (add) => {
    setLoading(true)
    add();
    setTimeout(() => {
      setLoading(false);
    }, 400)
  }

  const handleRemoveFields = (remove, name) => {
    setLoading(true)
    remove(name);
    setTimeout(() => {
      setLoading(false);
    }, 400)
  }

  const refreshData = async() => {
    if(tableRef.current){
      await tableRef.current.fetchWithoutResetPage();
    }
  }

  const handleClose = () => {
    setOpenPopover(false);
  };

  const columns = [
    {
      title: 'Action',
      dataIndex: 'id',
      width: 120,
      key: 'Action',
      render: (value) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Tooltip triger='hover' title={"ประวัติรถ"}>
            <ColorButton
              type='primary'
              override={'#48CAE4'}
              style={{ marginRight : 10}}
              icon={<HistoryOutlined />}
              onClick={()=> window.open(`${window.origin}${PATH.POND_TRUCK_HISTORY}/${value}`)} 
            /></Tooltip>
          <Popover
            key={value}
            ref = {popoverRef}
            open= {openPopover === value ? true : false}
            trigger="click"
            overlayStyle={{ width: 'auto' ,height: 'auto'}}
            placement="bottom"
            destroyOnHidden
            onOpenChange={() => {
              form.resetFields();
              if(openPopover === value){
                setOpenPopover(false)
              } else {
                setOpenPopover(value)
              }
            }}
            content={(
            <Spin spinning={loading}>
            <Form form={form} style={{ height : 'auto', width : 'auto'}}>
              <Row>
                <Col>
                  <Form.Item
                    name={'pond_transaction'}
                    layout={'vertical'}                                                                                                                               
                    label={'เลือกบ่อ'}
                    style={{ height : 60}}
                    rules={[{ required : true, mesage: "กรุณาเลือกบ่อ"  }]}
                  >
                    <Select 
                      showSearch
                      options={pondDropdown.options} 
                      style={{ width : 200, marginRight : 10}} 
                      placeholder={'บ่อ'}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onSearch={debouncePond}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item
                    name={'tray'}
                    layout={'vertical'}                                                                                                                               
                    label={'กระบะ'}
                    style={{ height : 60}}
                  >
                    <Input style={{ width : 150}} placeholder={'กระบะ'} autoComplete={'off'}/>
                  </Form.Item>
                </Col>
              </Row>
              
              {/* NewSorces */}
              {multiplePondFeature ? <Form.List name="sources" >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                        <Form.Item
                          name={[name, 'pond_transaction']}
                          layout={'vertical'}                                                                                                                               
                          label={'เลือกบ่อ'}
                          style={{ height : 60}}
                          rules={[{ required : true, message: "กรุณาเลือกบ่อ"  }]}
                        >
                          <Select 
                            showSearch
                            options={pondDropdown.options} 
                            style={{ width : 200 }} 
                            placeholder={'บ่อ'}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onSearch={debouncePond}
                          />
                        </Form.Item>
                        <Form.Item
                          label={'น้ำหนัก'}
                          layout={'vertical'}
                          {...restField}
                          name={[name, 'weight']}
                        >
                          <InputNumber placeholder="น้ำหนัก" style={{ width : 150}} rules={[{ required : true, message: "กรุณากรอกน้ำหนัก" }]}/>
                        </Form.Item>
                        <Form.Item
                          layout={'vertical'}                                                                                                                               
                          label={'กระบะ'}
                          style={{ height : 60 }}
                          {...restField}
                          name={[name, 'tray']}
                        >
                          <Input style={{ width : 150}} placeholder={'กระบะ'} autoComplete={'off'}/>
                        </Form.Item>
                        <MinusCircleOutlined style={{ width : 20}} onClick={() => handleRemoveFields(remove, name)} />
                      </Space>
                    ))}
                <div style={{ height : 40, marginTop : 10 }}>
                  <ColorButton type="dashed" onClick={() => { handleAddFields(add);}} block icon={<PlusOutlined />} style={{ width : 200, marginBottom : 30}} >
                    เพิ่มบ่อเทน้ำยาง 
                  </ColorButton>
                  <ColorButton 
                    type='primary'
                    override={colorSuccess}
                    onClick={()=> handleFillLatex(value)} 
                    style={{ float : 'right',  marginLeft : 10}}
                    loading={loading}
                  >
                    ตกลง
                  </ColorButton>

                  <ColorButton 
                    onClick={handleClose}
                    style={{ float : 'right'}}
                  >
                    ปิด
                  </ColorButton>
                    </div>
                      </>
                  )}
              </Form.List> : 
              <div style={{ height : 40, marginTop : 10 }}>
                <ColorButton 
                  type='primary'
                  override={colorSuccess}
                  onClick={()=> handleFillLatex(value)} 
                  style={{ float : 'right',  marginLeft : 10}}
                  loading={loading}
                >
                  ตกลง
                </ColorButton>

                <ColorButton 
                  onClick={handleClose}
                  style={{ float : 'right'}}
                >
                  ปิด
                </ColorButton>
              </div>
              }

            </Form>
            </Spin>
            )}
            >
              <Tooltip triger='hover' title={"เทน้ำยางลงบ่อ"}>
              <ColorButton 
                type='primary'
                override={colorSuccess}
                icon={<CheckOutlined />}
              /></Tooltip>
            </Popover>
          </div>
      )}
    },
    {
      title: "ลำดับ",
      dataIndex: "index",
      key: "index",
      render : (value) => <center>{value}</center>
    },
    {
      title: "เที่ยวที่",
      dataIndex: "round_trip",
      key: "round_trip",
      render : (value) => <center>{value}</center>
    },
    {
      title: 'ทะเบียน',
      dataIndex: 'vehicle_license_plate',
      key: 'vehicle_license_plate ',
    },
    {
      title: 'น้ำหนักประมาณ',
      dataIndex: 'estimated_weight',
      key: 'estimated_weight',
      render : (value) => <center>{formatComma(toFixed(value, 0))}</center>
    },
    {
      title: "ผลแล็บ",
      dataIndex: "",
      key: "lab_results",
      render: (value, original) => {
        return _.get(original, "lab_results", "-").map((item) => {
          return (
            <div style={{ color: getLabResultColor(_.get(item, 'status', null)) }}>
              <Tooltip title={item.note}>{item.chemical} : {toFixed(item.amount, 3)}</Tooltip>
            </div>
          );
        });
      },
    },
  ]

  React.useEffect(() => {
    if(open){
      handleClose();
      setErrorMessages(null)
      pondDropdown.fetchOptions();
      refreshData();
    }
  },[open])

  React.useEffect(() => {
    if(open){
      pondDropdown.fetchOptions();
    }
  },[debouncedPond])

  return(
    <Modal
      open={open}
      onCancel={async() => {
        await onUpdate()
      }}
      keyboard={false}
      title={'เติมน้ำยางสด'}
      width={750}
      footer={[
        <ColorButton onClick={() => onUpdate()} >
          {"ปิด"}
        </ColorButton>
      ]}
    >
      <ErrorMessages message={errorMessages}/>
        <TSTable
          ref={tableRef}
          columns={columns}
          size={'small'}
          pageSize={999}
          url={URL_TRUCK.TRUCK_TRANSACTION}
          params={{pond_available : true}}
          hidePagination={true}
        />
    </Modal>
  )
}